import React from 'react';
import Home2 from '../components/template2/Home2';

const Home = () => {
  return <Home2 />;
};

export default Home;
